import React from "react";
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink } from "@react-pdf/renderer";
import { Spinner } from "reactstrap";

const currencyFormat = (num) => {
  return parseFloat(num || 0).toLocaleString("id-ID");
};

const formatSaldo = (saldo) => {
  if (saldo < 0) {
    return `(${currencyFormat(Math.abs(saldo))})`;
  }
  return currencyFormat(saldo);
};

const ProfitLossPDF = ({ data }) => {
  const pendapatan = data.pendapatan?.total ?? 0;
  const bebanPokok = data.bebanPokokPendapatan?.total ?? 0;
  const bebanOperasional = data.bebanOperasional?.total ?? 0;
  const pendapatanLainnya = data.pendapatanLainnya?.total ?? 0;

  const labaKotor = pendapatan - bebanPokok;

  const labaOperasional = pendapatan - bebanPokok - bebanOperasional;

  const labaRugi = pendapatan - bebanPokok - bebanOperasional + pendapatanLainnya;
  return (
    <Document>
      <Page size="A4" style={{ padding: 30, paddingTop: 128, paddingBottom: 60, fontSize: 10, fontFamily: "Helvetica" }} wrap>
        <View fixed style={{ position: "absolute", top: 30, left: 30, right: 30, fontWeight: "bold" }}>
          <View style={{ marginBottom: 20 }}>
            <Text>PT HIKMAH ALAM SENTOSA</Text>
            <Text>LABA RUGI</Text>
            <Text>01/01/2024 - 31/12/2024</Text>
            <Text style={{ fontSize: 8 }}>(dalam IDR)</Text>
          </View>
          <View style={{ flexDirection: "row", justifyContent: "space-between", width: "100%", fontSize: 12, fontWeight: "normal", padding: 8, backgroundColor: "#00c7ff", color: "#ffffff", marginBottom: 4 }}>
            <Text>{"Tanggal"}</Text>
            <Text>{"31/01/01/2024 - 31/12/2024/2024"}</Text>
          </View>
        </View>

        <View>
          <View style={{ backgroundColor: "#f0f0f0", padding: 8, borderBottom: "1px solid #ddd" }}>
            <Text style={{ fontWeight: "bold" }}>{data.pendapatan?.label}</Text>
          </View>

          <View style={{ marginLeft: 20 }}>
            {data.pendapatan?.data.map((account) => (
              <View
                key={account.code}
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingVertical: 6,
                  paddingHorizontal: 8,
                  borderBottom: "1px solid #eee",
                }}
              >
                <Text>
                  {account.code} - {account.name.trimStart()}
                </Text>
                <Text>{formatSaldo(account.headerSaldo)}</Text>
              </View>
            ))}
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              padding: 8,
              borderTop: "1px solid #000",
              fontWeight: "bold",
            }}
          >
            <Text>Total dari {data.pendapatan?.label}</Text>
            <Text>{formatSaldo(data.pendapatan?.total)}</Text>
          </View>
        </View>

        {/* Beban Pokok Pendapatan */}
        <View>
          <View style={{ backgroundColor: "#f0f0f0", padding: 8, borderBottom: "1px solid #ddd" }}>
            <Text style={{ fontWeight: "bold" }}>{data.bebanPokokPendapatan?.label}</Text>
          </View>

          <View style={{ marginLeft: 20 }}>
            {data.bebanPokokPendapatan?.data.map((account) => (
              <View
                key={account.code}
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingVertical: 6,
                  paddingHorizontal: 8,
                  borderBottom: "1px solid #eee",
                }}
              >
                <Text>
                  {account.code} - {account.name.trimStart()}
                </Text>
                <Text>{formatSaldo(account.headerSaldo)}</Text>
              </View>
            ))}
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              padding: 8,
              borderTop: "1px solid #000",
              fontWeight: "bold",
            }}
          >
            <Text>Total dari {data.bebanPokokPendapatan?.label}</Text>
            <Text>{formatSaldo(data.bebanPokokPendapatan?.total)}</Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              padding: 8,
              borderTop: "1px solid #aaa",
              fontWeight: "bold",
            }}
          >
            <Text>Laba Kotor</Text>
            <Text>{formatSaldo(labaKotor)}</Text>
          </View>
        </View>

        {/* Beban Operasional */}
        <View>
          <View style={{ backgroundColor: "#f0f0f0", padding: 8, borderBottom: "1px solid #ddd" }}>
            <Text style={{ fontWeight: "bold" }}>{data.bebanOperasional?.label}</Text>
          </View>

          <View style={{ marginLeft: 20 }}>
            {data.bebanOperasional?.data.map((account) => (
              <View
                key={account.code}
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingVertical: 6,
                  paddingHorizontal: 8,
                  borderBottom: "1px solid #eee",
                }}
              >
                <Text>
                  {account.code} - {account.name.trimStart()}
                </Text>
                <Text>{formatSaldo(account.headerSaldo)}</Text>
              </View>
            ))}
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              padding: 8,
              borderTop: "1px solid #000",
              fontWeight: "bold",
            }}
          >
            <Text>Total dari {data.bebanOperasional?.label}</Text>
            <Text>{formatSaldo(data.bebanOperasional?.total)}</Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              padding: 8,
              borderTop: "1px solid #aaa",
              fontWeight: "bold",
            }}
          >
            <Text>Laba Operasional</Text>
            <Text>{formatSaldo(labaOperasional)}</Text>
          </View>
        </View>

        {/* Pendapatan (Beban) Lain-lain */}
        <View>
          <View style={{ backgroundColor: "#f0f0f0", padding: 8, borderBottom: "1px solid #ddd" }}>
            <Text style={{ fontWeight: "bold" }}>Pendapatan (Beban Lain-lain)</Text>
          </View>

          <View style={{ marginLeft: 20 }}>
            <View style={{ padding: 8, borderBottom: "1px solid #ddd", fontWeight: "bold" }}>
              <Text>{data.pendapatanLainnya?.label}</Text>
            </View>

            <View style={{ marginLeft: 40 }}>
              {data.pendapatanLainnya?.data.map((account) => (
                <View
                  key={account.code}
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingVertical: 6,
                    paddingHorizontal: 8,
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <Text>
                    {account.code} - {account.name.trimStart()}
                  </Text>
                  <Text>{formatSaldo(account.headerSaldo)}</Text>
                </View>
              ))}
            </View>
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              padding: 8,
              borderTop: "1px solid #000",
              fontWeight: "bold",
            }}
          >
            <Text>Total dari Pendapatan (Beban Lain-lain)</Text>
            <Text>{formatSaldo(data.pendapatanLainnya?.total)}</Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              padding: 8,
              borderTop: "1px solid #aaa",
              fontWeight: "bold",
              backgroundColor: "#e8f4ff",
            }}
          >
            <Text>Laba (Rugi)</Text>
            <Text>{formatSaldo(labaRugi)}</Text>
          </View>
        </View>

        <View fixed style={{ position: "absolute", bottom: 30, left: 30, right: 30 }}>
          <View>
            <View style={{ height: 1, width: "100%", backgroundColor: "#000000", marginTop: 10, marginBottom: 10 }}></View>
            <View style={{ flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
              <Text>Neraca : PT Hikmah Alam Sentosa per tanggal 31/12/2024</Text>
              <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

const Export = ({ data }) => {
  return (
    <PDFDownloadLink document={<ProfitLossPDF data={data} />} fileName="Laporan_Laba_Rugi.pdf" className="btn btn-success">
      {({ blob, url, loading, error }) => {
        return (
          <>
            <i className="ri-file-download-line me-1 align-bottom fs-14"></i>
            Export {loading ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
          </>
        );
      }}
    </PDFDownloadLink>
  );
};

export default Export;
